module.exports = __webpack_public_path__ + "img/how-to-find-a-product-or-family.50171d7a.png";